import { Link } from "react-router-dom";
import { BRAND } from "@/brand";

const QUICK_LINKS = [
  { to: "/", label: "Home" },
  { to: "/how-it-works", label: "How it works" },
  { to: "/rates", label: "Rates" },
  { to: "/accepted-cards", label: "Accepted cards" },
  { to: "/blog", label: "Spark" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

const LEGAL_LINKS = [
  { to: "/legal/privacy", label: "Privacy" },
  { to: "/legal/terms", label: "Terms" },
  { to: "/legal/refund", label: "Refund policy" },
  { to: "/track", label: "Track an order" },
];

export default function Footer() {
  const y = new Date().getFullYear();
  return (
    <footer className="footer-section lm_footer_sect" data-testid="site-footer">
      <div className="main-container">
        <div className="footer-container">
          {/* Brand + contact */}
          <div className="footer-column">
            <nav className="footer-logo-wrapper">
              <Link to="/" className="footer-logo-link w-inline-block lm-brand" style={{ display: "inline-flex", alignItems: "center", textDecoration: "none" }}>
                <img
                  src="/wordmark-light.png"
                  alt="GC SPARK"
                  style={{ height: 38, width: "auto", objectFit: "contain", display: "block" }}
                />
              </Link>
            </nav>
            <p style={{ color: "#aab0cc", maxWidth: 340, lineHeight: 1.7, marginTop: 18 }}>
              GC SPARK is an independent online gift card exchange platform owned and operated
              by {BRAND.ownerName}, based in {BRAND.ownerCountry}. GC SPARK is not affiliated
              with, endorsed by, or sponsored by the brands whose gift cards may be accepted
              on our platform.
            </p>
            <ul role="list" className="footer-links-list w-list-unstyled" style={{ marginTop: 20 }}>
              <li className="footer-list-item">
                <a href={`mailto:${BRAND.supportEmail}`} className="footer-office-contact" data-testid="footer-support-email">
                  {BRAND.supportEmail}
                </a>
              </li>
            </ul>
          </div>

          {/* Quick links */}
          <nav className="footer-nav-column">
            <div className="footer-line-heading-wrapper"><div>Quick links</div></div>
            <ul role="list" className="footer-links-list w-list-unstyled">
              {QUICK_LINKS.map((l) => (
                <li className="footer-list-item" key={l.to}>
                  <Link to={l.to} className="footer-link">{l.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Legal */}
          <nav className="footer-nav-column">
            <div className="footer-line-heading-wrapper"><div>Legal</div></div>
            <ul role="list" className="footer-links-list w-list-unstyled">
              {LEGAL_LINKS.map((l) => (
                <li className="footer-list-item" key={l.to}>
                  <Link to={l.to} className="footer-link">{l.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Sell CTA */}
          <nav className="footer-nav-column">
            <div className="footer-line-heading-wrapper"><div>Get started</div></div>
            <p style={{ color: "#aab0cc", lineHeight: 1.65, maxWidth: 220 }}>
              Get a quote in seconds — no account needed.
            </p>
            <Link to="/submit" className="primary-button w-button" style={{ width: "auto", padding: "13px 26px", display: "inline-block", marginTop: 14 }} data-testid="footer-sell-btn">
              Sell a card
            </Link>
          </nav>
        </div>

        {/* Bottom: disclaimer + copyright */}
        <div className="boss-footer-bottom">
          <p data-testid="footer-independence-disclaimer" style={{ color: "#8a90b3", fontSize: 13, lineHeight: 1.7, maxWidth: 980, marginBottom: 14 }}>
            GC SPARK is an independent gift card resale platform. We purchase eligible gift cards
            from customers and pay cash after verification. GC SPARK is not owned by, endorsed by,
            sponsored by, or officially affiliated with Apple, Amazon, Visa, Mastercard, or any
            other brands displayed on this website. All trademarks, logos, and brand names are the
            property of their respective owners and are used solely to identify eligible gift card
            brands.
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: 8 }}>
            <p style={{ color: "#8a90b3", fontSize: 13 }} data-testid="footer-operated-by">
              © {y} GC SPARK · {BRAND.operatingRegion}
            </p>
            <p style={{ color: "#8a90b3", fontSize: 13 }}>
              Every card reviewed by a real person — fair rates, secure payouts, no bots.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
